import script from "./AddComptable.vue?vue&type=script&setup=true&lang=js"
export * from "./AddComptable.vue?vue&type=script&setup=true&lang=js"

import "./AddComptable.vue?vue&type=style&index=0&id=24959d0e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24959d0e"]])

export default __exports__